import { track } from "@amplitude/analytics-react-native";
import { useEffect } from "react";
import MarkGatheringViewedDocument from "src/api/graphql/__generated__/documents/MarkGatheringViewedDocument";
import GatheringViewMethod from "src/api/graphql/__generated__/enums/GatheringViewMethod";
import { useAsyncMutation } from "src/api/graphql/helper";
import { getCurTime_S } from "src/shared/helpers/timeHelpers";
import { Timestamp_MS } from "src/shared/types/general";
import usePersistenceStore from "src/stores/usePersistenceStore";

const MarkGatheringViewed = ({
	gatheringId,
	method,
	delay_MS = 2000,
}: {
	gatheringId: string;
	method: GatheringViewMethod;
	delay_MS?: Timestamp_MS;
}) => {
	const markGatheringViewed = useAsyncMutation(MarkGatheringViewedDocument);

	useEffect(() => {
		if (gatheringId) {
			const timeout = setTimeout(async () => {
				const interactionEntry =
					usePersistenceStore.getState().gatheringInteractionData[gatheringId];
				const lastViewedAt = interactionEntry?.lastViewedAt;
				usePersistenceStore.setState((state) => ({
					gatheringInteractionData: {
						...state.gatheringInteractionData,
						[gatheringId]: {
							lastViewedAt: getCurTime_S(),
						},
					},
				}));
				track("gathering_view", {
					gatheringId,
					method,
					lastViewedAt,
				});
				await markGatheringViewed({
					input: {
						gatheringId,
						method,
						// Backend handles debouncing lastViewedAt
						lastViewedAt,
					},
					context: {
						pinBehavior: "inert",
					},
				});
			}, delay_MS);
			return () => clearTimeout(timeout);
		}
		return;
	}, [markGatheringViewed, gatheringId, method, delay_MS]);

	return null;
};
export default MarkGatheringViewed;
